import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { useNavigate } from 'react-router-dom';
import IranMap from 'Assets/Images/iranmap.svg'
const Producers = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();
    useEffect(() => {
        if (currentLang !== 'fa') {
            navigate('/');;
        }
    }, [currentLang, navigate]);
    const content = {
        fa: {
            description: (
                <>
                    در این قسمت می‌توانید بر اساس
                    <strong className="fw-bold"> عرضه‌کنندگان بر حسب انتخاب استان یا دسته‌بندی محصولات </strong>
                    را مشاهده‌کنید
                </>
            ),
            list: [
                "تولیدکنندگان یا عرضه‌کنندگان محصولات پتروشیمی",
                "تولیدکنندگان یا عرضه‌کنندگان محصولات پالایشی",
                "تولیدکنندگان یا عرضه‌کنندگان برق",
                "تولیدکنندگان یا عرضه‌کنندگان انرژی‌های پاک",
                "تولیدکنندگان یا عرضه‌کنندگان محصولات معدن",
                "تولیدکنندگان یا عرضه‌کنندگان محصولات آبی",
                "تولیدکنندگان یا عرضه‌کنندگان سایر حامل‌های انرژی",
            ],
        },

        en: {
            description: (
                <>
                    Here you can view
                    <strong className="fw-bold"> suppliers based on province selection or product categorization </strong>
                </>
            ),
            list: [
                "Producers or suppliers of petrochemical products",
                "Producers or suppliers of refinery products",
                "Producers or suppliers of electricity",
                "Producers or suppliers of clean energy",
                "Producers or suppliers of mining products",
                "Producers or suppliers of water-related products",
                "Producers or suppliers of other energy carriers",
            ],
        },

        ar: {
            description: (
                <>
                    يمكنك هنا عرض
                    <strong className="fw-bold"> المورّدين حسب اختيار المحافظة أو تصنيف المنتجات </strong>
                </>
            ),
            list: [
                "المنتجون أو المورّدون للمنتجات البتروكيميائية",
                "المنتجون أو المورّدون لمنتجات التكرير",
                "المنتجون أو المورّدون للكهرباء",
                "المنتجون أو المورّدون للطاقة النظيفة",
                "المنتجون أو المورّدون لمنتجات التعدين",
                "المنتجون أو المورّدون للمنتجات المائية",
                "المنتجون أو المورّدون لسائر ناقلات الطاقة",
            ],
        },
    };


    const { description, list } = content[currentLang] || content.fa; // fallback to fa

    return (
        <div className="megaMenuContent">
            <div className="row">
                <div className="col-6">
                    <div className="row justify-content-between h-100">
                        <div className="col-8">
                            <p className="text-nowrap">{description}</p>
                            <ul className="IeeStatuteList">
                                {list.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>

                        </div>
                        <div className="col-12 d-flex align-items-end">
                            <a href="/Listing/Producers" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                                {t("go_to_dashboard")}
                                <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                    {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                                </span>
                            </a>

                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <img src={IranMap} className="w-100" />
                </div>
            </div>
        </div>
    );
};

export default Producers;
